import { render, staticRenderFns } from "./FixDeskIndex.vue?vue&type=template&id=491edab4&scoped=true"
import script from "./FixDeskIndex.vue?vue&type=script&lang=js"
export * from "./FixDeskIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491edab4",
  null
  
)

export default component.exports